export default "__VITE_ASSET__BUHhRWO0__"